<template>
    <label class="icon-check" :class="{checked}">
        <input :type="input_type" v-model="modelValue" :value="value" @change="change">
        <span class="icon" v-if="$slots.icon || image">
            <slot name="icon" v-if="$slots.icon"/>
            <img :src="image" v-else alt=""/>
        </span>
        <span class="label" v-if="$slots.default">
            <slot/>
        </span>
    </label>
</template>

<script>
export default {
    name: "ImageCheck",
    emits: ['change', 'update:modelValue'],
    props: ['modelValue', 'value', 'image', 'type'],

    data(){
        return {
        }
    },

    computed: {
        input_type(){
            return this.type ? this.type : 'checkbox';
        },

        checked(){
            try{
                return this.type === 'radio' ? `${this.modelValue}` === `${this.value}` : this.modelValue.includes(this.value);
            }catch (e) {
                console.log({V: this.modelValue});
            }
        }

    },

    methods: {

        change(){
            this.$emit('update:modelValue', this.modelValue);
            this.$emit('change', this.modelValue);
        },

    },

}
</script>

<style lang="scss" scoped>
.icon-check{
    display: flex;
    flex-direction: column;
    user-select: none;
    text-align: center;
    border-radius: .3rem;
    box-shadow: rgba($dark, 0.2) 0 0 2px;
    border: transparent solid 2px;
    padding: .75rem;
    background: white;
    transition: box-shadow .3s;
    cursor: pointer;

    &:hover{
        box-shadow: rgba($dark, 0.15) 0 2px 12px;
        border: $primary dotted 2px;
    }

    &.checked{
        border: $primary solid 2px;
    }

    &.show-input{
        input{
            display: block;
        }
    }
}
input{
    display: block;
    margin: 0 auto .6rem;

    &[type="radio"]{
        display: none;
    }
}
.icon{
    display: block;

    img{
        display: block;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
    }
}

.label{
    margin-top: .6rem;
}
</style>
